module.exports = __webpack_public_path__ + "img/vip-executive-saldanha-hotel.b5a36a6c.jpg";